import { IconButton } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

const CustomIconButton = styled(IconButton)`
    float: left;
    display: inline-block;
    background: none;
    margin-top: 3px;

    min-height: 18px;
    height: 18px;
    min-width: 18px;
    width: 18px;

    &:hover {
        background: none;
    }

    svg {
        circle,
        path {
            stroke: var(--chakra-colors-gray-500);
        }

        &[aria-expanded='true'] {
            circle,
            path {
                stroke: var(--chakra-colors-blue-400);
            }
        }
    }
`;

export default CustomIconButton;
